import {StatutEvenement} from '../../shared/models/statut-evenement.model';

export class ValiderRefuserJoursTeletravailDto {
	jourTeletravailIds: number[];
	statut: StatutEvenement;
	loginResponsable: string;

	constructor(jourTeletravailIds: number[], statut: StatutEvenement, loginResponsable: string) {
		this.jourTeletravailIds = jourTeletravailIds;
		this.statut = statut;
		this.loginResponsable = loginResponsable;
	}
}
